import React from 'react';
import { formatValueWithoutCurrency } from '../../../helpers/currency.helper';

interface IBalanceViewProps {
  balance: number;
  testId: string;
  currencyClassName?: string;
  balanceClassName?: string;
  wrapperClassName?: string;
}

export const BalanceView = ({
  balance,
  testId,
  currencyClassName,
  balanceClassName,
  wrapperClassName,
}: IBalanceViewProps) => (
  <div className={`font-metricR text-sm text-bw08 leading-6 ${wrapperClassName}`}>
    {balance < 0 && (
      <span data-testid={testId} className={`${balanceClassName || 'font-metricRSemibold text-sm'}`}>
        -
      </span>
    )}
    <span className={currencyClassName}>$</span>
    <span data-testid={testId} className={`${balanceClassName || 'font-metricRSemibold text-sm'}`}>
      {formatValueWithoutCurrency(Math.abs(balance), 2)}
    </span>
  </div>
);
